import React from "react";
import styles from "./BidtoolContainer.module.scss";
import clsx from "clsx";
interface BidtoolContainerProps {
  headerTitles: string[];
  small?: boolean;
  children?: React.ReactNode;
  containerOne?: boolean;
}
const BidtoolContainer = ({
  headerTitles,
  children,
  small,
  containerOne,
  scrollable,
}: BidtoolContainerProps) => {
  return (
    <div
      className={clsx({
        [styles.BidtoolContainer]: !small,
        [styles.BidtoolContainersmall]: small,
      })}
    >
      <div
        className={clsx({
          [styles.BidtoolHeader]: !small,
          [styles.BidtoolHeaderSmall]: small,
          [styles.BidtoolHeaderContainerOne]: containerOne && !small,
        })}
      >
        {headerTitles.map((title) => (
          <p>{title}</p>
        ))}
      </div>
      <div
        className={clsx({
          [styles.BidToolContainerContent]: !small,
          [styles.BidToolContainerContentSmall]: small,
          [(styles.BidToolContainerContent, styles.Scrollable)]:
            !small && scrollable,
        })}
      >
        {children}
      </div>
    </div>
  );
};

export default BidtoolContainer;
